import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold tracking-tight transition-colors focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-1",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-gold text-ink",
        secondary:
          "border-hair bg-cream text-ink",
        destructive:
          "border-transparent bg-red-100 text-red-700",
        outline: "border-hair text-slate-600 bg-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
